import Tooltip from '@liveauctioneers/caterwaul-components/lib/Tooltip/Tooltip';
import { Amount } from '@liveauctioneers/caterwaul-components/lib/types/Amount';
import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedNumber } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import { ReactNode } from 'react';

type Props = {
    amount: Amount;
    bold?: boolean;
    infoText?: ReactNode;
    label: ReactNode;
};

export const InvoiceSummaryListRow = ({ amount, bold, infoText, label }: Props) => {
    const Text = bold ? H5 : BodySecondary;
    return (
        <div className="mb-sm flex w-full items-center justify-between">
            <div className="flex items-center">
                <Text>{label}</Text>
                {Boolean(infoText) && (
                    <Tooltip
                        placement="top"
                        trigger={
                            <Info
                                className="inline-flex"
                                color="primary"
                                size="xs"
                            />
                        }
                    >
                        {infoText}
                    </Tooltip>
                )}
            </div>
            <Text>
                <FormattedNumber
                    currency={amount.currency || 'USD'}
                    key="invoice-summary-list-row-amount"
                    maximumFractionDigits={2}
                    minimumFractionDigits={2}
                    style="currency"
                    value={amount.amount || 0}
                />
            </Text>
        </div>
    );
};
